import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import { MarketingAutomationConfigKeys } from "kadow-jetpack-model";

export default function (
  accountToDisplay: ManagedAccount | undefined | null,
  maKey: MarketingAutomationConfigKeys | "win" | "ml_win" | "ltycm"
) {
  switch (maKey) {
    case MarketingAutomationConfigKeys.grant_tokens_15th:
      return !!accountToDisplay?.saasFeatures?.mas?.grant_tokens_15th;

    case MarketingAutomationConfigKeys.onboarding:
      return !!accountToDisplay?.saasFeatures?.mas?.onboarding;

    case MarketingAutomationConfigKeys.ml_loser:
      return !!accountToDisplay?.saasFeatures?.mas?.ml_loser;

    case MarketingAutomationConfigKeys.birthday:
      return !!accountToDisplay?.saasFeatures?.mas?.birthday;

    case MarketingAutomationConfigKeys.reminder:
      return !!accountToDisplay?.saasFeatures?.mas?.reminder;

    case "win":
      return true;

    default:
      return false;
  }
}
